
import { Vue } from "vue-class-component";

export default class BackgroundImage extends Vue {}
